import { useParams, usePathname } from 'next/navigation';
import CategoryLink from './components/links';

const categories = {
  woman: 'Женское',
  man: 'Мужское',
  children: 'Детское',
  home: 'Товары для дома',
};
export default function TagBar() {
  const { section } = useParams() as { section: string };
  const pathname = usePathname();
  const decodedPathname = decodeURI(pathname);
  // console.log('pathname', decodedPathname);

  return (
    <>
      <ul
        className={`flex ${section === 'children' || section === 'home' ? 'justify-start' : 'justify-between'} gap-2 overflow-x-auto whitespace-nowrap py-2`}
      >
        {/* <CategoryLink
          category={'Бьюти'}
          link={'/catalog/beauty'}
          section={section || 'woman'}
          decodedPathname={decodedPathname}
        />

        <CategoryLink
          category={'Очки'}
          link={'/catalog/optics'}
          section={section || 'woman'}
          decodedPathname={decodedPathname}
        /> */}

        {Object.entries(categories).map(([key, value]) => (
          <CategoryLink
            key={key}
            category={value}
            link={`/catalog/${key}`}
            section={section || 'woman'}
            decodedPathname={decodedPathname}
          />
        ))}
      </ul>
    </>
  );
}
